import React, {useState} from 'react'
import Popup from './TeamPopUp';
import '../css/Popup.css'
import imagesPath from '../config/imagesPath';


const MeetTheTeam = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedMember, setSelectedMember] = useState();

    const togglePopup = () => {
        setIsOpen(!isOpen);
    }

    const teams = [
        {
            "name": "Sameer Aggarwal",
            "designation": "CEO & Founder",
            "linkedin": "https://www.linkedin.com/in/sameer-aggarwal-39069a/",
            "websiteLink": "https://sameeraggarwal.com/",
            "img": imagesPath.img24,
            "content": "Sameer is an alumnus of IIT Kharagpur and a former banker who has held several leadership positions in consumer credit risk,lending products and analytics. He has worked across six continents with various customer segments.Sameer also provides expert views,writes articles in popular media and blogs on various topics including leadership,start-ups, entrepreneurship, fintech, lending and risk management.",
            "experience": "",
            "experience1": "",

        },
        {
            "name": "Ranjit Yadav",
            "designation": "Mentor",
            "linkedin": "https://www.linkedin.com/in/ ranjit-yadav-3531145/",
            "websiteLink": "",
            "img": imagesPath.img19,
            "content": "Ex- CarDekho, Tata Motors, Samsung",
            "experience": "",
            "experience1": "",
        },
        {
            "name": "Monika Saxena",
            "designation": "Chief Strategy Officer",
            "linkedin": "https://www.linkedin.com/in/monika-saxena-6a357545",
            "img": imagesPath.img29,
            "websiteLink": "",
            "content": "Customer, Sustainability & People",
            "experience": "20+ years of experience in Entrepreneurship, Sales, Consulting and Organizational Development ",
            "experience1": "Ex-American Express, Samsung and NIIT"
        },
        {
            "name": "Sushil Kumar Jain",
            "designation": " National Head - Collections",
            "linkedin": "https://www.linkedin.com/in/sushil-kumar-jain-109730b3 ",
            "img": imagesPath.img36,
            "content": "Collections",
            "experience": " Accomplished 23+ Years enriched Experience in NBFC for Collection or Recovery Profile.",
            "experience1": "Previously working with Toyota Financial Services India Ltd./TVS Credit Services Ltd./Shriram City union Finance Ltd./Magma Fincorp Ltd./Satin Credit care Network Ltd."
        },
        {
            "name": "Deepa Vegesina ",
            "designation": "Chief Digital Officer",
            "linkedin": "https://www.linkedin.com/in/deepa-vegesina",
            "img": imagesPath.img32,
            "websiteLink": "",
            "content": "Digital platform, engineering",
            "experience": "15+ years experience in digital transformation projects ",
            "experience1": "Ex-Infosys, Amadeus, Toyota and Bekaert"
        },
        {
            "name": "Payal Maini",
            "designation": "Head of Operations",
            "linkedin": "https://www.linkedin.com/in/payal-maini-442020ba",
            "websiteLink": "",
            "img": imagesPath.img23,
            "content": "Process and capabilities ",
            "experience": "7+ years experience in consumer lending and Fintech",
            "experience1": "Ex-Paytm"
        },
        {
            "name": "Aashish Pareek",
            "designation": "Head – EV Partnerships",
            "linkedin": "https://www.linkedin.com/in/pareekashish",
            "websiteLink": "",
            "img": imagesPath.img21,
            "content": "EV distribution and partnerships ",
            "experience": "20+ years of experience in marketing & distribution",
            "experience1": "Ex- Shigan Evoltz Limited & Luminous."
        },
        {
            "name": "Nikhil Arora",
            "designation": "Head of Investor Relations",
            "linkedin": "https://www.linkedin.com/in/nikhil-arora-72934974",
            "websiteLink": "",
            "img": imagesPath.img39,
            "content": "Investor Relations",
            "experience": "6 years of experience in Finance and Investor Relations",
            "experience1": "Previously worked with Northern Arc Capital, EY and PwC"
        },
        {
            "name": "Ishita Bhardwaj",
            "designation": "Legal Counsel",
            "linkedin": "https://www.linkedin.com/in/ishita-bhardwaj",
            "img": imagesPath.img30,
            "websiteLink": "",
            "content": "Legal",
            "experience": "9+ years of PQE in M&A, private equity and corporate commercial advisory ",
            "experience1": "Ex-Shardul Amarchand Mangaldas & Company, KT Advisors LLP",
        }

    ]

    return (
        <section id="team" className="team meetourteam section-bg">
            <div className="container">
                <section id="services" className="services">
                    <div className="container" data-aos="fade-up">
                        <div className="section-titles">
                            <h3 className="heading_tow">MEET THE TEAM</h3>
                        </div>
                    </div>
                </section>
                <div className="row pt-4 row-justify-center">
                    {teams.map((ele, index) => {
                        return (<div className="col-lg-4 col-md-6 team_meet" style={{
                            paddingLeft: '80px',
                            paddingRight: '80px'
                        }} key={index}>
                            <div className="member-img borderimg">
                                <img src={ele.img} className="img-fluid" alt=""
                                     style={{
                                         width: '100%',
                                     }}/></div>
                            <div className="member-info">
                                <h4>{ele.name}</h4> <span>{ele.designation}</span></div>
                            <div className="social-networking">
                                <a href={ele.linkedin} target="_blank"><i className="bi bi-linkedin"></i></a>
                                {ele.websiteLink && <a href={ele.websiteLink} target="_blank"><i
                                    className="bi bi-box-arrow-in-up-right"></i></a>}
                            </div>
                            <button href="#" className="morebtnwhite" onClick={() => {
                                setSelectedMember(ele);
                                togglePopup()
                            }}>MORE <i className="bi bi-chevron-right"></i></button>
                            {isOpen && <Popup
                                content={selectedMember}
                                handleClose={togglePopup}
                            />}
                        </div>)
                    })}


                </div>
            </div>
            <div className="gray-bgcolor"></div>
            <div className="blue-bgcolor"></div>
        </section>
    )
}

export default MeetTheTeam



// WEBPACK FOOTER //
// ./src/components/MeetTheTeam.js